import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Copyright from '../../internals/components/Copyright';
import ProfileDisplay from './ProfileDisplay';

export default function MainGridProfile({ category }) {
    return (
        <>
            <Box sx={{ width: '90vw', maxWidth: { sm: '100%', md: '1700px', lg: '90vw' }, display: 'flex', flexDirection: 'column' }}>
                <Grid
                    container
                    spacing={2}
                    columns={12}
                    sx={{ mb: (theme) => theme.spacing(2), alignItems: 'center', justifyContent: 'center' }}
                >
                    <ProfileDisplay />
                </Grid>
                <Copyright sx={{ my: 4 }} />
            </Box>
        </>
    );

};